import { compose } from 'redux'
import { connect } from 'react-redux'
import { StyleSheet } from 'aphrodite'

const styleSheet = StyleSheet.create({
  dotParent: {
    ':hover span': {
      visibility: 'visible',
    },
  },
  pinDot: {
    height: '1rem',
    width: '1rem',
    borderRadius: '50%',
    display: 'block',
    margin: 'auto',
  },
  pinText: {
    display: 'block',
    visibility: 'hidden',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    backgroundColor: 'white',
    minWidth: 'fit-content',
  },
})

export default compose(connect(() => ({ styleSheet })))



// WEBPACK FOOTER //
// ./src/components/MapPin/MapPin.enhancer.js